import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Cart, Search } from "./icons";
import { Badge } from "./Badge";
import { SearchFieldFullWidth } from "./SearchFieldFullWidth";
import { bestReadableColor } from "./utils";
import { readableColor } from "polished";
import styled from "@emotion/styled";
import { useFlexMenu } from "./useFlexMenu";
import { useRef } from "react";
import { colors } from "../theme";
import { Tooltip } from "./Tooltip";
import { Trans } from "@lingui/react";
const hoverOpacity = "0.6";
export function RTCHeaderDesktop1({ backgroundColor, bannerActive, bannerBackgroundColor, bannerContent, bannerTypography, bannerVisibility, containerSize, disabledCart, homeUrl, isInHome, itemsCount, logoColor, logoContent, logoImage, logoType, logoTypography, menu, menuMoreButtonText, menuTypography, onCartIconClick, onSearch, renderLink, searchOpen, searchPlaceholder, searchTerm, secondaryColor, setSearchOpen, sticky, textColor, }) {
    var _a;
    const flexMenu = useFlexMenu(menu, 36);
    const searchIconRef = useRef(null);
    const logoImageParse = logoImage != null && logoImage !== ""
        ? JSON.parse(logoImage)
        : undefined;
    const showBanner = bannerActive &&
        ((bannerVisibility === "H" && isInHome) || bannerVisibility === "A");
    return (_jsxs(Header, Object.assign({ backgroundColor: backgroundColor, sticky: sticky }, { children: [showBanner && (_jsx(Banner, Object.assign({ backgroundColor: bannerBackgroundColor }, { children: _jsx(BannerContent, { dangerouslySetInnerHTML: { __html: bannerContent }, typography: bannerTypography, textColor: bestReadableColor(textColor, bannerBackgroundColor) }, void 0) }), void 0)),
            _jsx(Container, Object.assign({ backgroundColor: backgroundColor }, { children: _jsxs(Content, { children: [logoType === "T" && (_jsx(Logo, Object.assign({ typography: logoTypography, color: logoColor }, { children: _jsx("a", Object.assign({ href: homeUrl, title: logoContent }, { children: logoContent }), void 0) }), void 0)),
                        logoType === "I" && (_jsx(LogoImage, { children: _jsx("a", Object.assign({ href: homeUrl, title: logoContent }, { children: _jsx("img", { src: logoImageParse === null || logoImageParse === void 0 ? void 0 : logoImageParse.medium, alt: "Logo de tu marca" }, void 0) }), void 0) }, void 0)),
                        _jsxs(Navigation, Object.assign({ backgroundColor: backgroundColor, containerWidth: containerSize.width, ref: flexMenu.listRef }, { children: [menu.map(({ id, title }) => (_jsx(InvisibleLink, Object.assign({ href: "#", typography: menuTypography, textColor: "black", className: "invisible-link", tabIndex: -1 }, { children: title }), id))),
                                flexMenu.visibleLinks.map(({ id, title, href, type }) => (_jsx(LinkContainer, Object.assign({ borderColor: secondaryColor, isActive: href === "/"
                                        ? isInHome
                                        : window.location.pathname.includes(href) }, { children: _jsx(Link, Object.assign({ textColor: bestReadableColor(textColor, backgroundColor), typography: menuTypography }, { children: type === "L" || renderLink == null ? (_jsx("a", Object.assign({ title: title, href: href }, (type === "L"
                                            ? { rel: "noopener noreferrer", target: "_blank" }
                                            : {}), { children: title }), void 0)) : (renderLink({ title, href })) }), void 0) }), id))),
                                _jsxs(ShowMore, Object.assign({ ref: flexMenu.showMoreButtonRef, isPresent: flexMenu.isMoreButtonVisible }, { children: [_jsx(LinkContainer, Object.assign({ borderColor: secondaryColor, isActive: false }, { children: _jsxs(MoreButton, Object.assign({ normalColor: bestReadableColor(textColor, backgroundColor), typography: menuTypography }, flexMenu.moreButtonHandlers, { children: [menuMoreButtonText, " ", _jsx(Chevron, {}, void 0)] }), void 0) }), void 0),
                                        _jsx(HiddenLinks, Object.assign({ show: flexMenu.showHiddenLinks }, flexMenu.hiddenLinksHandlers, { children: flexMenu.hiddenLinks.map(({ id, href, title, type }) => (_jsx(HiddenLink, Object.assign({ typography: menuTypography, linkColor: bestReadableColor(textColor, colors.white) }, { children: type === "L" || renderLink == null ? (_jsx("a", Object.assign({ title: title, href: href }, (type === "L"
                                                    ? { rel: "noopener noreferrer", target: "_blank" }
                                                    : {}), { children: title }), void 0)) : (renderLink({ title, href })) }), id))) }), void 0)] }), void 0)] }), void 0),
                        _jsx(IconButton, Object.assign({ color: readableColor(backgroundColor), "data-testid": "search-icon", id: "search-icon", onClick: () => setSearchOpen(o => !o) }, { children: _jsx(Search, { ref: searchIconRef }, void 0) }), void 0),
                        _jsx(Tooltip, Object.assign({ content: _jsx(Trans, { id: "No pod\u00E9s agregar productos al carrito en este momento" }, void 0), placement: "bottom-end", maxWidth: 200, disabled: !disabledCart }, { children: _jsx(IconButtonWrapper, { children: _jsx(IconButton, Object.assign({ color: readableColor(backgroundColor), onClick: onCartIconClick, "data-testid": "cart", disabled: disabledCart, disabledCart: disabledCart }, { children: itemsCount >= 1 ? (_jsx(Badge, Object.assign({ badgeContent: itemsCount, disabledCart: disabledCart }, { children: _jsx(Cart, {}, void 0) }), void 0)) : (_jsx(Cart, {}, void 0)) }), void 0) }, void 0) }), void 0),
                        _jsx(SearchFieldFullWidth, { arrow: "right", open: searchOpen, desktop: true, placeholder: searchPlaceholder, searchIconPosition: (_a = searchIconRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(), onBlur: e => {
                                const relatedButton = e.relatedTarget;
                                if ((relatedButton === null || relatedButton === void 0 ? void 0 : relatedButton.id) !== "search-icon") {
                                    setSearchOpen(false);
                                }
                            }, onSearch: onSearch, searchTerm: searchTerm }, void 0)] }, void 0) }), void 0)] }), void 0));
}
const Header = styled.header(({ backgroundColor, sticky }) => (Object.assign({ backgroundColor, border: "none", boxShadow: "0 2px 4px hsla(0, 0%, 0%, 0.15)", display: "flex", flexDirection: "column", height: "auto", position: sticky ? "sticky" : "relative", width: "100%" }, (sticky
    ? {
        top: 0,
        zIndex: 9999,
    }
    : {}))));
const Banner = styled.div(({ backgroundColor }) => ({
    alignItems: "center",
    backgroundColor,
    display: "grid",
    gridTemplateColumns: "1fr 96rem 1fr",
    minHeight: "5rem",
}));
const BannerContent = styled.div(({ typography, textColor }) => ({
    color: textColor,
    fontFamily: typography,
    fontSize: "1.4rem",
    gridColumn: "2 / 3",
    textAlign: "center",
    padding: "1.6rem",
    "& p": {
        margin: 0,
        fontFamily: typography,
    },
}));
const Container = styled.div(({ backgroundColor }) => ({
    backgroundColor,
    display: "grid",
    gridTemplateColumns: "1fr 96rem 1fr",
    height: "13rem",
    position: "relative",
}));
const Content = styled.div({
    display: "grid",
    gridColumn: "2 / 3",
    gridGap: "0.4rem",
    //                      logo   menu   search  cart
    gridTemplateColumns: "17.6rem 65.6rem 5.6rem 5.6rem",
    height: "13rem",
});
const Logo = styled.div(({ typography, color }) => ({
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
    maxHeight: "13rem",
    overflow: "hidden",
    wordBreak: "break-word",
    "& a": {
        textDecoration: "none",
        fontSize: "3.2rem",
        fontFamily: typography,
        color,
    },
}));
const Navigation = styled.nav(() => ({
    alignItems: "center",
    display: "grid",
    gridAutoFlow: "column",
    gridGap: "3.6rem",
    justifyContent: "start",
}));
const LinkContainer = styled.div(({ borderColor, isActive }) => {
    const underlineWidth = "80%";
    return Object.assign({ display: "flex", flexDirection: "column", position: "relative", textAlign: "center", "&:after": {
            backgroundColor: borderColor,
            content: "' '",
            height: 2,
            margin: "0 auto",
            transform: "scaleX(0)",
            transition: "transform 200ms ease-in-out",
            width: underlineWidth,
            position: "absolute",
            bottom: 0,
            left: `calc((100% - ${underlineWidth}) /2)`,
        }, "&:hover:after": {
            transform: "scaleX(1)",
        } }, (isActive
        ? {
            "&:after": {
                backgroundColor: borderColor,
                content: "' '",
                height: 2,
                margin: "0 auto",
                width: underlineWidth,
                position: "absolute",
                bottom: 0,
                left: `calc((100% - ${underlineWidth}) /2)`,
            },
        }
        : {}));
});
const Link = styled.span(({ textColor, typography }) => ({
    padding: "0.8rem 0",
    "& > a": {
        color: textColor,
        textDecoration: "none",
        fontFamily: typography,
        fontSize: "1.6rem",
        whiteSpace: "nowrap",
    },
}));
const InvisibleLink = styled.a(({ textColor, typography }) => ({
    position: "fixed",
    top: "-200%",
    pointerEvents: "none",
    color: textColor,
    padding: "0.8rem 0",
    textDecoration: "none",
    fontFamily: typography,
    fontSize: "1.6rem",
    whiteSpace: "nowrap",
}));
const padding = "1.6rem";
const ShowMore = styled.div(({ isPresent }) => ({
    display: isPresent ? "block" : "none",
    position: "relative",
}));
const MoreButton = styled.span(({ normalColor, typography }) => ({
    alignItems: "center",
    color: normalColor,
    display: "inline-grid",
    fontFamily: typography,
    fontSize: "1.6rem",
    gridAutoFlow: "column",
    gridGap: "0.4rem",
    lineHeight: "3.8rem",
    "& svg": {
        color: normalColor,
        height: "2.4rem",
        width: "2.4rem",
    },
}));
const HiddenLinks = styled.div(({ show }) => ({
    backgroundColor: colors.white,
    boxShadow: "0 0.4rem 0.8rem hsla(0, 0%, 0%, 0.15)",
    display: "flex",
    flexDirection: "column",
    gridGap: "0.8rem",
    maxWidth: "34rem",
    opacity: show ? 1 : 0,
    pointerEvents: show ? "all" : "none",
    position: "absolute",
    transform: `translate(calc(-50% + (${padding} * 2)), ${show ? 0 : -1}rem)`,
    top: "3.6rem",
    transformOrigin: "top center",
    transition: "all 200ms ease-in-out",
    width: "max-content",
    zIndex: show ? 100 : -100,
    wordBreak: "break-word",
}));
const HiddenLink = styled.span(({ typography, linkColor }) => ({
    padding: `calc(${padding} / 2) 1.2rem`,
    transition: "background-color 200ms ease-in-out",
    "& > a": {
        textDecoration: "none",
        color: linkColor,
        fontFamily: typography,
        fontSize: "1.6rem",
        textAlign: "left",
    },
    "&:hover": {
        backgroundColor: colors.greyLightest,
    },
}));
const Chevron = () => (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 512" }, { children: _jsx("path", { fill: "currentColor", d: "M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z" }, void 0) }), void 0));
const IconButtonWrapper = styled.span(() => ({
    alignSelf: "center",
}));
const IconButton = styled.button(({ color, disabledCart }) => ({
    alignItems: "center",
    alignSelf: "center",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    display: "flex",
    height: "4rem",
    justifyContent: "center",
    justifySelf: "end",
    margin: "0 -0.8rem 0 0",
    padding: "0",
    width: "4rem",
    "& svg": {
        color: disabledCart ? colors.greyMain : color,
        fontSize: "2rem",
    },
    "&:hover": {
        opacity: disabledCart ? 1 : hoverOpacity,
    },
}));
const LogoImage = styled.div(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "0.8rem",
    "& img": {
        maxWidth: "15rem",
        maxHeight: "7.2rem",
        objectFit: "cover",
    },
}));
//# sourceMappingURL=RTCHeaderDesktop1.js.map